module.exports = __webpack_public_path__ + "img/chat.9e77f9d4.png";